import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
const Resources = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const resources = [{
    title: 'The Complete Guide to AEO',
    type: 'Guide',
    color: 'text-accent bg-accent/10 border-accent/20',
    desc: "Everything you need to know about Answer Engine Optimization and why it matters for your brand's future."
  }, {
    title: "GEO vs SEO: What's the Difference?",
    type: 'Blog Post',
    color: 'text-accentwarm bg-accentwarm/10 border-accentwarm/20',
    desc: 'Understanding the key differences between traditional SEO and Generative Engine Optimization strategies.'
  }, {
    title: 'How AI Search is Changing Discovery',
    type: 'Report',
    color: 'text-purple-600 bg-purple-100 border-purple-200',
    desc: 'Our 2026 report on how ChatGPT, Perplexity, and Google AI Overviews are fundamentally reshaping brand discovery.'
  }, {
    title: 'Optimizing Content for AI Citations',
    type: 'Guide',
    color: 'text-accent bg-accent/10 border-accent/20',
    desc: 'A step-by-step framework for creating and structuring content that AI engines actively want to cite.'
  }, {
    title: 'Case Study: 3x Visibility in 90 Days',
    type: 'Case Study',
    color: 'text-green-600 bg-green-100 border-green-200',
    desc: 'How an enterprise SaaS company tripled their AI search visibility and inbound leads using Steward.'
  }, {
    title: 'Schema Markup for AEO',
    type: 'Tutorial',
    color: 'text-blue-600 bg-blue-100 border-blue-200',
    desc: 'A technical guide to implementing structured data that helps AI engines better understand your content.'
  }];
  return <main className="flex-grow bg-gray-50" data-id="element-439">
      {/* Hero Section */}
      <div className="bg-primary pt-20 pb-24 text-center px-4 sm:px-6 lg:px-8" data-id="element-440">
        <div className="max-w-3xl mx-auto" data-id="element-441">
          <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl" data-id="element-442">
            Resources & Insights
          </h1>
          <p className="mt-6 text-xl text-textlight" data-id="element-443">
            Stay ahead of the AI search revolution with our latest guides, case
            studies, and industry insights.
          </p>
        </div>
      </div>

      {/* Resources Grid */}
      <div className="max-w-7xl mx-auto py-20 px-4 sm:px-6 lg:px-8" data-id="element-444">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-445">
          {resources.map((resource, index) => <div key={index} className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col h-full" data-id="element-446">
              <div className="mb-4" data-id="element-447">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${resource.color}`} data-id="element-448">
                  {resource.type}
                </span>
              </div>
              <h3 className="text-xl font-bold text-customblack mb-3" data-id="element-449">
                {resource.title}
              </h3>
              <p className="text-customgray text-sm leading-relaxed flex-grow mb-6" data-id="element-450">
                {resource.desc}
              </p>
              <a href="#" className="text-accent font-medium text-sm hover:text-cyan-600 flex items-center mt-auto" data-id="element-451">
                Read more{' '}
                <span aria-hidden="true" className="ml-1" data-id="element-452">
                  &rarr;
                </span>
              </a>
            </div>)}
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="bg-white border-t border-gray-200 py-16" data-id="element-453">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-454">
          <h2 className="text-2xl font-bold text-customblack mb-4" data-id="element-455">
            Get the latest AEO insights weekly
          </h2>
          <form className="mt-6 flex max-w-md mx-auto gap-x-4" data-id="element-456">
            <label htmlFor="email-address" className="sr-only" data-id="element-457">
              Email address
            </label>
            <input id="email-address" name="email" type="email" autoComplete="email" required className="min-w-0 flex-auto rounded-lg border-0 px-4 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6" placeholder="Enter your email" data-id="element-458" />
            <button type="submit" className="flex-none rounded-lg bg-customblack px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900" data-id="element-459">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </main>;
};
export default Resources;